function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
import requiredImage from '../fragments/requiredImage.js';
import { simpleBlockContent } from '../index.js';
var schema = defineObject('mediaSection', {
    variant: {
        title: 'Variant',
        type: 'string',
        options: {
            list: [
                'default',
                'small',
                'wide',
                'fill'
            ]
        }
    },
    image: _object_spread({
        title: 'Image'
    }, requiredImage.fragment),
    label: {
        title: 'Label',
        type: 'string'
    },
    caption: _object_spread({
        title: 'Caption'
    }, simpleBlockContent.fragment),
    video: {
        title: 'Video URL',
        type: 'url',
        description: 'Vimeo or YouTube URL'
    }
}, []);
var validator = z.object({
    _type: z.literal('mediaSection'),
    variant: z.enum([
        'default',
        'small',
        'wide',
        'fill'
    ]).optional(),
    image: requiredImage.validator.optional(),
    label: z.string().optional(),
    caption: simpleBlockContent.validator.optional(),
    video: z.string().optional()
});
schema.mediaSection;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=mediaSection.js.map